import { useQuery } from "react-query";
import { getCarrierEANDOPerState } from "../actions/get";

const useGetCarrierEANDOPerStateData = () => {
  return useQuery({
    queryKey: ["carrier-eando-per-state"],
    queryFn: getCarrierEANDOPerState,
  });
};

export default useGetCarrierEANDOPerStateData;
